import { render, staticRenderFns } from "./BoardHome.vue?vue&type=template&id=36708c3c&scoped=true&"
import script from "./BoardHome.vue?vue&type=script&lang=js&"
export * from "./BoardHome.vue?vue&type=script&lang=js&"
import style0 from "./BoardHome.vue?vue&type=style&index=0&id=36708c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36708c3c",
  null
  
)

export default component.exports